import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppInterceptor } from './Services/app.interceptor';
import { HttpStatusInterceptor } from './Services/http-status.interceptor';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PreloadService } from './Services/preload.service';
import { EmLoaderComponent } from './Components/em-loader/em-loader.component';

export function preloadFactory(preloadService: PreloadService) {
  return () => preloadService.loadInitialData();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule, // Required for ngx-toastr animations
    FormsModule,
    EmLoaderComponent,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right', // Toast notification position
      timeOut: 3000, // Auto-dismiss timeout
      preventDuplicates: true, // Avoid duplicate toasts
    }),
  ],
  providers: [
    MessageService, // Provides message service for notifications
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpStatusInterceptor,
      multi: true,
    }, // Global HTTP status interceptor
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: preloadFactory,
      deps: [PreloadService],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()), // Uses standard XHR, natively intercepted by Zone.js
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
